import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegexPattern } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-registration-user-further-data',
  templateUrl: './registration-user-further-data.component.html',
  styleUrls: ['../registration.scss'],
})
export class RegistrationUserFurtherDataComponent {
  @Input() userForm!: FormGroup;
  @Input() showError = true;

  public static generateFormGroup(): FormGroup {
    return new FormGroup({
      phone: new FormControl(null, [Validators.pattern(RegexPattern.PHONE_PATTERN)]),
      position: new FormControl(null, [Validators.pattern(RegexPattern.XSS_PATTERN)]),
    });
  }
}
